// SHGalleryInfo.js

import React, { useContext } from 'react';
import './SHGalleryInfo.css';
import {
    TbCalendarTime,
    TbCreditCard,
    TbMapPin,
    TbMapSearch,
    TbDownload,
    TbShare,
    TbThumbUp
} from 'react-icons/tb';
import { useLanguage } from '../../../../../../LanguageProvider';
import Services from '../../../../../../services/Services';
import { GeneralContext } from '../../../../../../GeneralProvider';

export default function SHGalleryInfo({ onClose, file, getCollectionDetail, onDeleteFile }) {
    const token = localStorage.getItem('token')
    const { getTranslation } = useLanguage();
    const { userId } = useContext(GeneralContext);

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = file.fileURL;
        link.target = '_blank';       // yeni sekme, CORS kuralı yok
        // cross-origin download attribute çalışmaz, ama eğer sunucu header'ı doğru ayarladıysa otomatik indirir
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleLike = () => {
        Services.SocialHiveLikeFile(token, file.channelID, file.collectionID, file.fileID)
            .then((res) => {
                if (res.data.status) {
                    getCollectionDetail(file.collectionID)
                }
            })
            .catch((err) => {
                console.error(err)
            })
    }

    const handleUnlike = () => {
        Services.SocialHiveUnlikeFile(token, file.channelID, file.collectionID, file.fileID)
            .then((res) => {
                if (res.data.status) {
                    getCollectionDetail(file.collectionID)
                }
            })
            .catch((err) => {
                console.error(err)
            })
    }


    const hasUserById = () => {
        if (file.likes) {
            return file.likes.some(item =>
                item.userInfos &&
                item.userInfos.id === userId
            );
        }
        return false
    }


    return (
        <div className="sh-gallery-info-container">
            <div className="sh-gallery-info-card">
                <span className="sh-gallery-info-row-header">
                    <span>{file.title}</span>
                </span>

                <span className="sh-gallery-info-row-text">
                    {file.description}
                </span>

                {/* <span className="sh-gallery-info-row-header">
                    File Details
                </span>
                <span className="sh-gallery-info-row-header" style={{ marginTop: '15px' }}>
                    <span>File Type</span>
                    <span>PNG</span>
                </span>

                <span className="sh-gallery-info-row-header" style={{ marginTop: '15px' }}>
                    <span>Size</span>
                    <span>2 MB</span>
                </span>

                <span className="sh-gallery-info-row-header" style={{ marginTop: '15px' }}>
                    <span>Last Update</span>
                    <span>22/02/2025 11:24</span>
                </span>

                <span className="sh-gallery-info-row-header" style={{ marginTop: '15px' }}>
                    <span>Share</span>
                </span> */}

                <div className="sh-gallery-action-buttons">
                    <button type="button" className="sh-action-button download-button" onClick={handleDownload}>
                        <TbDownload className="action-icon" />
                        <span>{getTranslation("download")}</span>
                    </button>
                    {/* <button type="button" className="sh-action-button share-button">
                        <TbShare className="action-icon" />
                        <span>Share</span>
                    </button> */}
                    <button type="button" onClick={hasUserById() ? handleUnlike : handleLike} className="sh-action-button like-button">
                        <TbThumbUp className="action-icon" />
                        <span>{getTranslation("like")}</span>
                        <span className="like-count">{file.likes ? file.likes.length : "0"}</span>
                    </button>
                    {onDeleteFile && (
                        <button
                            type="button"
                            onClick={onDeleteFile}
                            className="sh-action-button danger-button"
                        >
                            <span>{getTranslation("deleteFile")}</span>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
